import kitsReducer from './reducer';
import * as kitsActions from './reducer';

export { kitsActions };

export default kitsReducer;
